<div class="profile-preference-section">
  <!-- Skeleton Loading State -->
  <div class="profile-skeleton-wrapper" *ngIf="isLoading">
    <!-- Hero Banner Skeleton -->
    <div class="skeleton-hero-card mb-4">
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-4">
        <div class="d-flex align-items-center gap-3">
          <div class="skeleton-avatar skeleton-shimmer"></div>
          <div class="d-flex flex-column gap-2">
            <div class="d-flex align-items-center gap-2">
              <div class="skeleton-title skeleton-shimmer"></div>
              <div class="skeleton-badge skeleton-shimmer"></div>
            </div>
            <div class="d-flex align-items-center gap-3 mt-1">
              <div class="skeleton-meta skeleton-shimmer"></div>
              <div class="skeleton-meta skeleton-shimmer"></div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center gap-2">
          <div class="skeleton-pill skeleton-shimmer"></div>
          <div class="skeleton-pill skeleton-shimmer"></div>
        </div>
      </div>
    </div>

    <!-- Cards Grid Skeleton -->
    <div class="row g-4">
      <!-- 1. Account Settings Card Skeleton -->
      <div class="col-12 col-xl-6">
        <div class="skeleton-card h-100">
          <div class="d-flex align-items-center justify-content-between mb-4">
            <div class="d-flex align-items-center gap-3">
              <div class="skeleton-icon-badge skeleton-shimmer"></div>
              <div class="d-flex flex-column gap-2">
                <div class="skeleton-card-title skeleton-shimmer"></div>
                <div class="skeleton-card-desc skeleton-shimmer"></div>
              </div>
            </div>
            <div class="skeleton-btn skeleton-shimmer"></div>
          </div>
          <div class="d-flex flex-column gap-3 mt-2">
            <div class="skeleton-field" *ngFor="let item of [1, 2, 3]">
              <div class="skeleton-label skeleton-shimmer mb-2"></div>
              <div class="skeleton-input skeleton-shimmer"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- 2. Company Details Card Skeleton -->
      <div class="col-12 col-xl-6">
        <div class="skeleton-card h-100">
          <div class="d-flex align-items-center justify-content-between mb-3">
            <div class="d-flex align-items-center gap-3">
              <div class="skeleton-icon-badge skeleton-shimmer"></div>
              <div class="d-flex flex-column gap-2">
                <div class="skeleton-card-title skeleton-shimmer"></div>
                <div class="skeleton-card-desc skeleton-shimmer"></div>
              </div>
            </div>
            <div class="skeleton-btn skeleton-shimmer"></div>
          </div>
          <div class="skeleton-callout skeleton-shimmer mb-3"></div>
          <div class="d-flex flex-column gap-3 mt-2">
            <div class="skeleton-field" *ngFor="let item of [1, 2]">
              <div class="skeleton-label skeleton-shimmer mb-2"></div>
              <div class="skeleton-input skeleton-shimmer"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- 3. Company Address Card Skeleton -->
      <div class="col-12 mt-3 mt-md-4">
        <div class="skeleton-card">
          <div class="d-flex align-items-center justify-content-between mb-4">
            <div class="d-flex align-items-center gap-3">
              <div class="skeleton-icon-badge skeleton-shimmer"></div>
              <div class="d-flex flex-column gap-2">
                <div class="skeleton-card-title skeleton-shimmer"></div>
                <div class="skeleton-card-desc skeleton-shimmer"></div>
              </div>
            </div>
            <div class="skeleton-btn skeleton-shimmer"></div>
          </div>
          <div class="row">
            <div class="col-12 mb-3 mb-md-4">
              <div class="skeleton-label skeleton-shimmer mb-2"></div>
              <div class="skeleton-textarea skeleton-shimmer"></div>
            </div>
            <div class="col-12 col-md-4 mb-3 mb-md-4" *ngFor="let item of [1, 2, 3]">
              <div class="skeleton-label skeleton-shimmer mb-2"></div>
              <div class="skeleton-input skeleton-shimmer"></div>
            </div>
            <div class="col-12 col-md-6 mb-3 mb-md-0" *ngFor="let item of [1, 2]">
              <div class="skeleton-label skeleton-shimmer mb-2"></div>
              <div class="skeleton-input skeleton-shimmer"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Real Content When Loaded -->
  <ng-container *ngIf="!isLoading && dealer">
    <!-- Profile Summary Hero Banner -->
    <div class="profile-hero-card mb-4">
      <div class="hero-bg-accent"></div>
      <div class="hero-content d-flex flex-wrap align-items-center justify-content-between gap-4">
        <div class="d-flex align-items-center gap-3">
          <div class="avatar-wrapper">
            <div class="avatar-bubble">
              <span>{{ userInitials }}</span>
            </div>
            <span class="avatar-status-badge" [class.status-online]="isProfileComplete" title="{{ (isProfileComplete ? 'Profile Complete' : 'Incomplete') | translate }}"></span>
          </div>
          <div class="user-meta">
            <div class="d-flex align-items-center gap-2 flex-wrap">
              <h3 class="user-name mb-0">{{ dealer_name || ('Store Partner' | translate) }}</h3>
              <span class="badge badge-verified">
                <i class="fi fi-rr-badge-check mr-1"></i>
                {{ "Verified Partner" | translate }}
              </span>
            </div>
            <div class="user-submeta d-flex align-items-center gap-3 flex-wrap mt-1">
              <span class="meta-item" *ngIf="dealer_email">
                <i class="fi fi-rr-envelope"></i>
                {{ dealer_email }}
              </span>
              <span class="meta-item" *ngIf="dealer_phone">
                <i class="fi fi-rr-phone-call"></i>
                {{ dealer_phone }}
              </span>
              <span class="meta-item" *ngIf="dealer_company_name">
                <i class="fi fi-rr-building"></i>
                {{ dealer_company_name }}
              </span>
            </div>
          </div>
        </div>

        <div class="hero-stats d-flex align-items-center gap-2">
          <div class="stat-pill">
            <span class="stat-dot" [class.dot-success]="isProfileComplete" [class.dot-warning]="!isProfileComplete"></span>
            <span class="stat-label">{{ (isProfileComplete ? "Account Active" : "Profile Pending") | translate }}</span>
          </div>
          <div class="stat-pill" *ngIf="dealer_company_name">
            <span class="stat-dot dot-success"></span>
            <span class="stat-label">{{ "Business Linked" | translate }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row g-4">
      <!-- Account Settings Card -->
      <div class="col-12 col-xl-6">
        <form [formGroup]="accountSettingForm" method="post" class="h-100">
          <div
            class="modern-card h-100 d-flex flex-column"
            [ngClass]="{
              'is-editing': edit1,
              'is-loading': showloader1
            }"
          >
            <!-- Card Header -->
            <div class="card-header-modern d-flex align-items-center justify-content-between mb-4">
              <div class="d-flex align-items-center gap-3">
                <div class="icon-badge icon-indigo">
                  <i class="fi fi-rr-user"></i>
                </div>
                <div>
                  <h4 class="card-title mb-0">{{ "Account Settings" | translate }}</h4>
                  <p class="card-desc mb-0">{{ "Manage your primary personal account credentials" | translate }}</p>
                </div>
              </div>
              <div>
                <button
                  type="button"
                  class="btn btn-outline-primary btn-sm d-inline-flex align-items-center"
                  *ngIf="!edit1"
                  (click)="editForm(1)"
                  [disabled]="showloader1"
                >
                  <i class="fi fi-rr-edit mr-1"></i>
                  <span>{{ "Edit" | translate }}</span>
                </button>
                <button
                  type="button"
                  class="btn btn-light btn-sm d-inline-flex align-items-center"
                  *ngIf="edit1"
                  (click)="editForm(1, false)"
                >
                  <i class="fi fi-rr-cross-small mr-1"></i>
                  <span>{{ "Cancel" | translate }}</span>
                </button>
              </div>
            </div>

            <!-- Card Body -->
            <div class="card-body-modern flex-grow-1">
              <!-- Dealer Name -->
              <div class="form-field-group mb-3">
                <label class="field-label">
                  {{ "Full Name" | translate }}
                  <span class="text-danger" *ngIf="edit1">*</span>
                </label>
                <div class="input-icon-wrapper">
                  <i class="fi fi-rr-user input-icon"></i>
                  <input
                    type="text"
                    class="form-control-modern"
                    formControlName="dealer_name"
                    [readonly]="!edit1"
                    (input)="accountSettingFormChange()"
                    (change)="accountSettingFormChange()"
                    placeholder="{{ 'Enter full name' | translate }}"
                    [ngClass]="{
                      'input-error':
                        accountSettingForm.get('dealer_name').errors &&
                        (accountSettingForm.get('dealer_name').touched ||
                          accountSettingForm.get('dealer_name').dirty)
                    }"
                  />
                </div>
                <div
                  class="field-error-msg"
                  *ngIf="
                    accountSettingForm.get('dealer_name').errors &&
                    (accountSettingForm.get('dealer_name').touched ||
                      accountSettingForm.get('dealer_name').dirty)
                  "
                >
                  <i class="fi fi-rr-info mr-1"></i>
                  <span>{{ "Name is required." | translate }}</span>
                </div>
              </div>

              <!-- Dealer Email -->
              <div class="form-field-group mb-3">
                <label class="field-label">
                  {{ "Email Address" | translate }}
                  <span class="text-danger" *ngIf="edit1">*</span>
                </label>
                <div class="input-icon-wrapper">
                  <i class="fi fi-rr-envelope input-icon"></i>
                  <input
                    type="email"
                    class="form-control-modern"
                    formControlName="dealer_email"
                    (input)="accountSettingFormChange()"
                    (change)="accountSettingFormChange()"
                    [readonly]="!edit1"
                    placeholder="{{ 'Enter email address' | translate }}"
                    [ngClass]="{
                      'input-error':
                        accountSettingForm.get('dealer_email').errors &&
                        (accountSettingForm.get('dealer_email').touched ||
                          accountSettingForm.get('dealer_email').dirty)
                    }"
                  />
                </div>
                <div
                  class="field-error-msg"
                  *ngIf="
                    accountSettingForm.get('dealer_email').errors &&
                    (accountSettingForm.get('dealer_email').touched ||
                      accountSettingForm.get('dealer_email').dirty)
                  "
                >
                  <i class="fi fi-rr-info mr-1"></i>
                  <span>{{ "Email is required." | translate }}</span>
                </div>
              </div>

              <!-- Dealer Phone -->
              <div class="form-field-group mb-3">
                <label class="field-label">
                  {{ "Phone Number" | translate }}
                  <span class="text-danger" *ngIf="edit1">*</span>
                </label>
                <div class="input-icon-wrapper">
                  <i class="fi fi-rr-phone-call input-icon"></i>
                  <input
                    type="text"
                    name="phone"
                    class="form-control-modern"
                    formControlName="dealer_phone"
                    (keypress)="numericOnly($event)"
                    [readonly]="!edit1"
                    (input)="accountSettingFormChange()"
                    (change)="accountSettingFormChange()"
                    placeholder="{{ 'Enter contact phone number' | translate }}"
                    [ngClass]="{
                      'input-error':
                        accountSettingForm.get('dealer_phone').errors &&
                        (accountSettingForm.get('dealer_phone').touched ||
                          accountSettingForm.get('dealer_phone').dirty)
                    }"
                  />
                </div>
                <div
                  class="field-error-msg"
                  *ngIf="
                    accountSettingForm.get('dealer_phone').errors &&
                    (accountSettingForm.get('dealer_phone').touched ||
                      accountSettingForm.get('dealer_phone').dirty)
                  "
                >
                  <i class="fi fi-rr-info mr-1"></i>
                  <span>{{ "Phone is required." | translate }}</span>
                </div>
              </div>
            </div>

            <!-- Card Footer Actions -->
            <div class="card-footer-modern mt-auto pt-3 border-top d-flex align-items-center justify-content-end gap-2" *ngIf="dealer && edit1">
              <button
                type="button"
                class="btn btn-light btn-sm"
                (click)="editForm(1, false)"
              >
                {{ "Cancel" | translate }}
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm d-inline-flex align-items-center"
                (click)="updateDealerInfo(1)"
                [disabled]="
                  !edit1 ||
                  accountSettingForm.get('dealer_phone').errors ||
                  accountSettingForm.get('dealer_email').errors ||
                  accountSettingForm.get('dealer_name').errors ||
                  !accountSettingDisable ||
                  showloader1
                "
              >
                <i class="fi fi-rr-check mr-1" *ngIf="!showloader1"></i>
                <span *ngIf="!showloader1">{{ "Save" | translate }}</span>
                <span *ngIf="showloader1">{{ "Saving..." | translate }}</span>
              </button>
            </div>

            <!-- Modern Card Loader -->
            <div class="card-loader-overlay" *ngIf="showloader1">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- Company Details Card -->
      <div class="col-12 col-xl-6">
        <form [formGroup]="companyDetailsForm" method="post" class="h-100">
          <div
            class="modern-card h-100 d-flex flex-column"
            [ngClass]="{
              'is-editing': edit3,
              'is-loading': showloader3
            }"
          >
            <!-- Card Header -->
            <div class="card-header-modern d-flex align-items-center justify-content-between mb-3">
              <div class="d-flex align-items-center gap-3">
                <div class="icon-badge icon-purple">
                  <i class="fi fi-rr-building"></i>
                </div>
                <div>
                  <h4 class="card-title mb-0">{{ "Company Details" | translate }}</h4>
                  <p class="card-desc mb-0">{{ "Official store and business branding credentials" | translate }}</p>
                </div>
              </div>
              <div>
                <button
                  type="button"
                  class="btn btn-outline-primary btn-sm d-inline-flex align-items-center"
                  *ngIf="!edit3"
                  (click)="editForm(3)"
                  [disabled]="showloader3"
                >
                  <i class="fi fi-rr-edit mr-1"></i>
                  <span>{{ "Edit" | translate }}</span>
                </button>
                <button
                  type="button"
                  class="btn btn-light btn-sm d-inline-flex align-items-center"
                  *ngIf="edit3"
                  (click)="editForm(3, false)"
                >
                  <i class="fi fi-rr-cross-small mr-1"></i>
                  <span>{{ "Cancel" | translate }}</span>
                </button>
              </div>
            </div>

            <!-- Informational Callout Box -->
            <div class="info-callout mb-3">
              <div class="d-flex gap-2">
                <i class="fi fi-rr-info callout-icon"></i>
                <span class="callout-text">
                  {{
                    "The official name of your business. If you don't have a registered business yet, specify your store name as the company name."
                      | translate
                  }}
                </span>
              </div>
            </div>

            <!-- Card Body -->
            <div class="card-body-modern flex-grow-1">
              <!-- Company Name -->
              <div class="form-field-group mb-3">
                <label class="field-label">
                  {{ "Company / Store Name" | translate }}
                </label>
                <div class="input-icon-wrapper">
                  <i class="fi fi-rr-briefcase input-icon"></i>
                  <input
                    type="text"
                    class="form-control-modern"
                    formControlName="dealer_company_name"
                    [readonly]="!edit3"
                    minlength="5"
                    (input)="companyDetailsFormChange()"
                    (change)="companyDetailsFormChange()"
                    placeholder="{{ 'Enter company or store brand name' | translate }}"
                    [ngClass]="{
                      'input-error': companyDetailsForm.get('dealer_company_name').errors?.minlength
                    }"
                  />
                </div>
                <div
                  class="field-error-msg"
                  *ngIf="
                    companyDetailsForm.get('dealer_company_name').errors?.minlength &&
                    (companyDetailsForm.get('dealer_company_name').touched ||
                      companyDetailsForm.get('dealer_company_name').dirty)
                  "
                >
                  <i class="fi fi-rr-info mr-1"></i>
                  <span>{{ "Company Name must be at least 5 characters in length." | translate }}</span>
                </div>
              </div>

              <!-- Company Email -->
              <div class="form-field-group mb-3">
                <label class="field-label">
                  {{ "Company Email" | translate }}
                </label>
                <div class="input-icon-wrapper">
                  <i class="fi fi-rr-envelope input-icon"></i>
                  <input
                    type="email"
                    class="form-control-modern"
                    formControlName="dealer_company_email"
                    [readonly]="!edit3"
                    minlength="6"
                    (input)="companyDetailsFormChange()"
                    (change)="companyDetailsFormChange()"
                    placeholder="{{ 'Enter public business or contact email' | translate }}"
                    [ngClass]="{
                      'input-error': companyDetailsForm.get('dealer_company_email').errors?.minlength
                    }"
                  />
                </div>
                <div
                  class="field-error-msg"
                  *ngIf="
                    companyDetailsForm.get('dealer_company_email').errors?.minlength &&
                    (companyDetailsForm.get('dealer_company_email').touched ||
                      companyDetailsForm.get('dealer_company_email').dirty)
                  "
                >
                  <i class="fi fi-rr-info mr-1"></i>
                  <span>{{ "Company Email must be at least 6 characters in length." | translate }}</span>
                </div>
              </div>
            </div>

            <!-- Card Footer Actions -->
            <div class="card-footer-modern mt-auto pt-3 border-top d-flex align-items-center justify-content-end gap-2" *ngIf="edit3">
              <button
                type="button"
                class="btn btn-light btn-sm"
                (click)="editForm(3, false)"
              >
                {{ "Cancel" | translate }}
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm d-inline-flex align-items-center"
                (click)="updateDealerInfo(3)"
                [disabled]="
                  !edit3 ||
                  companyDetailsForm.get('dealer_company_name').errors?.minlength ||
                  companyDetailsForm.get('dealer_company_email').errors?.minlength ||
                  !companyDetailsDisable ||
                  showloader3
                "
              >
                <i class="fi fi-rr-check mr-1" *ngIf="!showloader3"></i>
                <span *ngIf="!showloader3">{{ "Save" | translate }}</span>
                <span *ngIf="showloader3">{{ "Saving..." | translate }}</span>
              </button>
            </div>

            <!-- Modern Card Loader -->
            <div class="card-loader-overlay" *ngIf="showloader3">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- Company Address Card (Full Width with dedicated top spacing) -->
      <div class="col-12 mt-3 mt-md-4">
        <form [formGroup]="companyAddressForm" method="post">
          <div
            class="modern-card"
            [ngClass]="{
              'is-editing': edit4,
              'is-loading': showloader4
            }"
          >
            <!-- Card Header -->
            <div class="card-header-modern d-flex align-items-center justify-content-between mb-3">
              <div class="d-flex align-items-center gap-3">
                <div class="icon-badge icon-emerald">
                  <i class="fi fi-rr-marker"></i>
                </div>
                <div>
                  <h4 class="card-title mb-0">{{ "Company Address & Location" | translate }}</h4>
                  <p class="card-desc mb-0">
                    {{
                      "The physical address of your store or warehouse. Used for order dispatch and shipping calculation."
                        | translate
                    }}
                  </p>
                </div>
              </div>
              <div>
                <button
                  type="button"
                  class="btn btn-outline-primary btn-sm d-inline-flex align-items-center"
                  *ngIf="!edit4"
                  (click)="editForm(4)"
                  [disabled]="showloader4"
                >
                  <i class="fi fi-rr-edit mr-1"></i>
                  <span>{{ "Edit" | translate }}</span>
                </button>
                <button
                  type="button"
                  class="btn btn-light btn-sm d-inline-flex align-items-center"
                  *ngIf="edit4"
                  (click)="editForm(4, false)"
                >
                  <i class="fi fi-rr-cross-small mr-1"></i>
                  <span>{{ "Cancel" | translate }}</span>
                </button>
              </div>
            </div>

            <!-- Card Body Grid -->
            <div class="card-body-modern">
              <div class="row">
                <!-- Street Address (Full Width) -->
                <div class="col-12 mb-3 mb-md-4">
                  <div class="form-field-group mb-0">
                    <label class="field-label">
                      {{ "Street Address" | translate }}
                      <span class="text-danger" *ngIf="edit4">*</span>
                    </label>
                    <div class="input-icon-wrapper align-items-start">
                      <i class="fi fi-rr-marker input-icon"></i>
                      <textarea
                        class="form-control-modern form-textarea"
                        formControlName="street"
                        [readonly]="!edit4"
                        (input)="companyAddressFormChange()"
                        (change)="companyAddressFormChange()"
                        placeholder="{{ 'Enter street address, building, floor or suite...' | translate }}"
                        rows="3"
                        [ngClass]="{
                          'input-error':
                            companyAddressForm.get('street').errors &&
                            (companyAddressForm.get('street').touched ||
                              companyAddressForm.get('street').dirty)
                        }"
                      ></textarea>
                    </div>
                    <div
                      class="field-error-msg"
                      *ngIf="
                        companyAddressForm.get('street').errors &&
                        (companyAddressForm.get('street').touched ||
                          companyAddressForm.get('street').dirty)
                      "
                    >
                      <i class="fi fi-rr-info mr-1"></i>
                      <span>{{ "Street is required." | translate }}</span>
                    </div>
                  </div>
                </div>

                <!-- City -->
                <div class="col-12 col-md-4 mb-3 mb-md-4">
                  <div class="form-field-group mb-0">
                    <label class="field-label">
                      {{ "City" | translate }}
                      <span class="text-danger" *ngIf="edit4">*</span>
                    </label>
                    <div class="input-icon-wrapper">
                      <i class="fi fi-rr-building input-icon"></i>
                      <input
                        type="text"
                        class="form-control-modern"
                        formControlName="city"
                        [readonly]="!edit4"
                        (input)="companyAddressFormChange()"
                        (change)="companyAddressFormChange()"
                        placeholder="{{ 'City' | translate }}"
                        [ngClass]="{
                          'input-error':
                            companyAddressForm.get('city').errors &&
                            (companyAddressForm.get('city').touched ||
                              companyAddressForm.get('city').dirty)
                        }"
                      />
                    </div>
                    <div
                      class="field-error-msg"
                      *ngIf="
                        companyAddressForm.get('city').errors &&
                        (companyAddressForm.get('city').touched ||
                          companyAddressForm.get('city').dirty)
                      "
                    >
                      <i class="fi fi-rr-info mr-1"></i>
                      <span>{{ "City is required." | translate }}</span>
                    </div>
                  </div>
                </div>

                <!-- State / Province / Region -->
                <div class="col-12 col-md-4 mb-3 mb-md-4">
                  <div class="form-field-group mb-0">
                    <label class="field-label">
                      {{ "State / Province / Region" | translate }}
                      <span class="text-danger" *ngIf="edit4">*</span>
                    </label>
                    <div class="input-icon-wrapper">
                      <i class="fi fi-rr-flag input-icon"></i>
                      <input
                        type="text"
                        class="form-control-modern"
                        formControlName="state"
                        [readonly]="!edit4"
                        (input)="companyAddressFormChange()"
                        (change)="companyAddressFormChange()"
                        placeholder="{{ 'State / Region' | translate }}"
                        [ngClass]="{
                          'input-error':
                            companyAddressForm.get('state').errors &&
                            (companyAddressForm.get('state').touched ||
                              companyAddressForm.get('state').dirty)
                        }"
                      />
                    </div>
                    <div
                      class="field-error-msg"
                      *ngIf="
                        companyAddressForm.get('state').errors &&
                        (companyAddressForm.get('state').touched ||
                          companyAddressForm.get('state').dirty)
                      "
                    >
                      <i class="fi fi-rr-info mr-1"></i>
                      <span>{{ "State is required." | translate }}</span>
                    </div>
                  </div>
                </div>

                <!-- Zip / Postal Code -->
                <div class="col-12 col-md-4 mb-3 mb-md-4">
                  <div class="form-field-group mb-0">
                    <label class="field-label">
                      {{ "Zip / Postal Code" | translate }}
                      <span class="text-danger" *ngIf="edit4">*</span>
                    </label>
                    <div class="input-icon-wrapper">
                      <i class="fi fi-rr-envelope input-icon"></i>
                      <input
                        type="text"
                        class="form-control-modern"
                        formControlName="postal"
                        [readonly]="!edit4"
                        (input)="companyAddressFormChange()"
                        (change)="companyAddressFormChange()"
                        placeholder="{{ 'Postal Code' | translate }}"
                        [ngClass]="{
                          'input-error':
                            companyAddressForm.get('postal').errors &&
                            (companyAddressForm.get('postal').touched ||
                              companyAddressForm.get('postal').dirty)
                        }"
                      />
                    </div>
                    <div
                      class="field-error-msg"
                      *ngIf="
                        companyAddressForm.get('postal').errors &&
                        (companyAddressForm.get('postal').touched ||
                          companyAddressForm.get('postal').dirty)
                      "
                    >
                      <i class="fi fi-rr-info mr-1"></i>
                      <span>{{ "Postal is required." | translate }}</span>
                    </div>
                  </div>
                </div>

                <!-- Country -->
                <div class="col-12 col-md-6 mb-3 mb-md-0">
                  <div class="form-field-group mb-0">
                    <label class="field-label">
                      {{ "Country" | translate }}
                      <span class="text-danger" *ngIf="edit4">*</span>
                    </label>
                    <div class="input-icon-wrapper">
                      <i class="fi fi-rr-globe input-icon"></i>
                      <input
                        type="text"
                        class="form-control-modern"
                        formControlName="country"
                        [readonly]="!edit4"
                        (input)="companyAddressFormChange()"
                        (change)="companyAddressFormChange()"
                        placeholder="{{ 'Country' | translate }}"
                        [ngClass]="{
                          'input-error':
                            companyAddressForm.get('country').errors &&
                            (companyAddressForm.get('country').touched ||
                              companyAddressForm.get('country').dirty)
                        }"
                      />
                    </div>
                    <div
                      class="field-error-msg"
                      *ngIf="
                        companyAddressForm.get('country').errors &&
                        (companyAddressForm.get('country').touched ||
                          companyAddressForm.get('country').dirty)
                      "
                    >
                      <i class="fi fi-rr-info mr-1"></i>
                      <span>{{ "Country is required." | translate }}</span>
                    </div>
                  </div>
                </div>

                <!-- Company Phone -->
                <div class="col-12 col-md-6 mb-3 mb-md-0">
                  <div class="form-field-group mb-0">
                    <label class="field-label">
                      {{ "Company Phone Number" | translate }}
                    </label>
                    <div class="input-icon-wrapper">
                      <i class="fi fi-rr-phone-call input-icon"></i>
                      <input
                        type="text"
                        class="form-control-modern"
                        formControlName="dealer_company_phone"
                        [readonly]="!edit4"
                        (input)="companyAddressFormChange()"
                        (change)="companyAddressFormChange()"
                        (keypress)="numericOnly($event)"
                        placeholder="{{ 'Company Phone (Optional)' | translate }}"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Card Footer Actions -->
            <div class="card-footer-modern mt-4 pt-3 border-top d-flex align-items-center justify-content-end gap-2" *ngIf="edit4">
              <button
                type="button"
                class="btn btn-light btn-sm"
                (click)="editForm(4, false)"
              >
                {{ "Cancel" | translate }}
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm d-inline-flex align-items-center"
                (click)="updateDealerInfo(4)"
                [disabled]="
                  !edit4 ||
                  companyAddressForm.get('street').errors ||
                  companyAddressForm.get('city').errors ||
                  companyAddressForm.get('state').errors ||
                  companyAddressForm.get('postal').errors ||
                  companyAddressForm.get('country').errors ||
                  !companyAddressDisable ||
                  showloader4
                "
              >
                <i class="fi fi-rr-check mr-1" *ngIf="!showloader4"></i>
                <span *ngIf="!showloader4">{{ "Save" | translate }}</span>
                <span *ngIf="showloader4">{{ "Saving..." | translate }}</span>
              </button>
            </div>

            <!-- Modern Card Loader -->
            <div class="card-loader-overlay" *ngIf="showloader4">
              <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- Appearance: glass or classic dashboard theme (saved in this browser) -->
      <div class="col-12 mt-3 mt-md-4">
        <div class="modern-card appearance-card">
          <div class="card-header-modern d-flex align-items-center justify-content-between mb-4">
            <div class="d-flex align-items-center gap-3">
              <div class="icon-badge icon-indigo">
                <i class="fi fi-rr-palette"></i>
              </div>
              <div>
                <h4 class="card-title mb-0">{{ "Appearance" | translate }}</h4>
                <p class="card-desc mb-0">{{ "Choose how the dashboard looks on this browser." | translate }}</p>
              </div>
            </div>
          </div>

          <div class="theme-options" role="radiogroup" [attr.aria-label]="'Appearance' | translate">
            <label class="theme-option" [class.selected]="uiTheme === 'glass'">
              <input type="radio" name="ui-theme" value="glass" [checked]="uiTheme === 'glass'"
                (change)="selectUiTheme('glass')" />
              <span class="theme-preview theme-preview-glass" aria-hidden="true">
                <span class="tp-sidebar"></span>
                <span class="tp-bar"></span>
                <span class="tp-panel"></span>
              </span>
              <span class="theme-text">
                <span class="theme-name">{{ "Glass" | translate }}</span>
                <span class="theme-desc">{{ "Frosted panels over a soft colour backdrop." | translate }}</span>
              </span>
              <span class="theme-radio" aria-hidden="true"></span>
            </label>

            <label class="theme-option" [class.selected]="uiTheme === 'classic'">
              <input type="radio" name="ui-theme" value="classic" [checked]="uiTheme === 'classic'"
                (change)="selectUiTheme('classic')" />
              <span class="theme-preview theme-preview-classic" aria-hidden="true">
                <span class="tp-sidebar"></span>
                <span class="tp-bar"></span>
                <span class="tp-panel"></span>
              </span>
              <span class="theme-text">
                <span class="theme-name">{{ "Classic" | translate }}</span>
                <span class="theme-desc">{{ "The original solid layout." | translate }}</span>
              </span>
              <span class="theme-radio" aria-hidden="true"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
